/**
 * Per-project viewer restrictions for the My Look Ahead Plan (#934).
 *
 * The backend resolves the current user's PROJECT role for each MLAP row and
 * stamps `readOnly: true` when that role is "viewer" (read but no edit/assign/
 * move) — on both the backlog (schedule activities) and the Task Focus gantt
 * (resource tasks). The FE carries that flag onto every Bryntum row record; the
 * helpers below read it uniformly to hide/disable mutating controls.
 *
 * Note this is independent of the GLOBAL `isViewer()` app role: a user who is a
 * project_manager globally can still be a viewer on a specific project.
 */
export const isRowReadOnly = (record) => {
  if (!record) return false;
  // Bryntum exposes data fields as record props, but fall back to `.data` in
  // case `readOnly` isn't a declared field on a given store.
  return Boolean(record.readOnly ?? record.data?.readOnly);
};
